import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './routers/AppRouter';
import WebFont from 'webfontloader';
import 'C:/apps/ideafy/src/components/styles/MainPageMobile.css'

WebFont.load({
    google: {
      families: ['Martel Sans:600,700,800,900', 'Roboto:900',  'sans-serif'],
    //   families: ['Roboto:900', 'sans-serif'],
      
    }
})

const App = () => (
    <div id = 'routerDiv'>
        <AppRouter/>
    </div>    
)

ReactDOM.render(<App/ >, document.querySelector('#root'))